import React from 'react'
import Card from '@mui/material/Card'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import CardActions from '@mui/material/CardActions'
import IconButton from '@mui/material/IconButton'
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'

import './product.css'

const Product = ({ product, onAddToCart }) => {

  return (

    <Card className="root">

      <CardMedia className="image" image={product.image.url} title={product.name} />

      <CardContent>

        <div className="cardContent">

          <Typography variant="h5" gutterBottom>
            {product.name}
          </Typography>

          <Typography variant="h5">
            {product.price.formatted_with_symbol}
          </Typography>

        </div>

        <Typography 
          variant="body2" 
          color="textSecondary" 
          dangerouslySetInnerHTML={{ __html: product.description }} 
        />   

      </CardContent>

      <CardActions className="cardActions">
        <IconButton onClick={() => onAddToCart(product.id, 1)}>
          <AddShoppingCartIcon />
        </IconButton>
      </CardActions>

    </Card>

  )

}

export default Product